import { FormikValues } from 'formik';
import React, { ComponentType } from 'react';
import { getDataLayer, tagManagerDataLayerEventNames } from 'src/lib/helpers';
import { SharedFormProps } from './form.types';
import FormRender from './FormRender';
import SubmissionMessageComponentDefault, {
  Props as SubmissionMessageComponentProps,
} from './SubmissionMessage';


export interface Props extends SharedFormProps {
  submissionMessageComponent?: ComponentType<SubmissionMessageComponentProps>,
  submissionSuccessText?: string,
  submissionFailureText?: string,
  formName?: string,
}


const Form:React.FC<Props> = ({
  submissionMessageComponent: submissionMessageComponentProp,
  fields,
  onSubmit,
  validationErrorComponent,
  submitComponent,
  preSubmitComponent,
  fieldsContainerComponent,
  submitContainerComponent,
  labelComponent,
  fieldWrapComponent,
  fieldInnerWrapComponent,
  formName = '',
}) => {
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [submissionError, setSubmissionError] = React.useState<Error>();
  const handleSubmit = async (values: FormikValues): Promise<any> => {
    const dataLayer = getDataLayer();
    try {
      await onSubmit(values);
      dataLayer.push({
        event: tagManagerDataLayerEventNames.FORM_SUBMISSION_SUCCESSFUL,
        formName,
      });
    } catch (error) {
      setSubmissionError(error);
      dataLayer.push({
        event: tagManagerDataLayerEventNames.FORM_SUBMISSION_FAILED,
        formName,
        error: JSON.stringify(error),
      });
    } finally {
      setIsSubmitted(true);
    }
  };


  const SubmissionMessageComponent = (
    submissionMessageComponentProp
    || SubmissionMessageComponentDefault
  );
  return (
    <div>
      <FormRender
        onSubmit={handleSubmit}
        fields={fields}
        validationErrorComponent={validationErrorComponent}
        submitComponent={submitComponent}
        preSubmitComponent={preSubmitComponent}
        fieldsContainerComponent={fieldsContainerComponent}
        submitContainerComponent={submitContainerComponent}
        labelComponent={labelComponent}
        fieldWrapComponent={fieldWrapComponent}
        fieldInnerWrapComponent={fieldInnerWrapComponent}
      />
      {isSubmitted && (
        <SubmissionMessageComponent submissionError={submissionError} />
      )}
    </div>
  );
};
export default Form;
